import { AfUbs, SeqsimHit } from '../../models/Seqsim';

export function formatPercent(fraction: number | null, digits = 0): string {
   if (fraction == null || Number.isNaN(fraction)) return '–';
   return `${(fraction * 100).toFixed(digits)}%`;
}

export function formatEValue(value: number): string {
   if (value === 0) return '0';
   return value.toExponential(1);
}

export function formatResolution(value: number | null): string {
   if (value == null) return '–';
   return `${value.toFixed(1)} Å`;
}

export interface TopLigand {
   code: string;
   count: number;
   extra: number;
}

/** Most frequent CCD code. Ties break alphabetically. */
export function topLigand(counts: Record<string, number> | undefined): TopLigand | null {
   const entries = Object.entries(counts ?? {});
   if (entries.length === 0) return null;
   entries.sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]));
   return { code: entries[0][0], count: entries[0][1], extra: entries.length - 1 };
}

/** Share of distinct PDBs caught holo. Null when there is no apo/holo observation. */
export function holoFraction(holo: number, either: number): number | null {
   if (either <= 0) return null;
   return holo / either;
}

export function probGap(ubs: AfUbs): number | null {
   if (ubs.prob_apo == null || ubs.prob_holo == null) return null;
   return Math.abs(ubs.prob_holo - ubs.prob_apo);
}

export function identityTone(identity: number): 'strong' | 'medium' | 'weak' {
   const pct = identity * 100;
   if (pct >= 80) return 'strong';
   if (pct >= 50) return 'medium';
   return 'weak';
}

export interface UbsFlatRow {
   hit: SeqsimHit;
   ubs: AfUbs;
}

export function flattenUbs(hits: SeqsimHit[]): UbsFlatRow[] {
   const rows: UbsFlatRow[] = [];
   for (const hit of hits) {
      for (const ubs of hit.af_per_ubs ?? []) {
         rows.push({ hit, ubs });
      }
   }
   return rows;
}
